import { connect } from 'react-redux'
import TransactionHistoryModal from '../components/TransactionHistoryModal'
import { actionCreators } from '../modules/transactionHistory'

export default connect(
  null,
  actionCreators,
)(TransactionHistoryModal)
